export enum MENU_TYPES {
    game = 'game',
    link = 'link'
}
